'use strict';

const changeThemeByName = async ({ dispatch, getters }, { name, vuetify }) => {
  const theme = getters.getThemeByName(name);
  await dispatch('changeTheme', { theme, vuetify });
};

const changeTheme = ({ commit }, { theme, vuetify }) => {
  // TODO check this.
  vuetify.theme.themes.light.surface = theme.surface;
  vuetify.theme.themes.light['surface-border'] = theme['surface-border'];
  vuetify.theme.themes.light.surface2 = theme.surface2;
  vuetify.theme.themes.light['surface2-border'] = theme['surface2-border'];
  vuetify.theme.themes.light['primary-text-color'] = theme['primary-text-color'];
  vuetify.theme.themes.light['secondary-text-color'] = theme['secondary-text-color'];
  vuetify.theme.themes.light['side-item-active'] = theme['side-item-active'];
  vuetify.theme.themes.light['side-item-hover'] = theme['side-item-hover'];
  vuetify.theme.themes.light['conversation-sent-bubble'] = theme['conversation-sent-bubble'];
  vuetify.theme.themes.light['conversation-received-bubble'] = theme['conversation-received-bubble'];
  vuetify.theme.themes.light['conversation-border-bubble'] = theme['conversation-border-bubble'];
  vuetify.theme.themes.light['input-bg'] = theme['input-bg'];
  vuetify.theme.themes.light['input-bg2'] = theme['input-bg2'];
  vuetify.theme.themes.light['primary-button-hover'] = theme['primary-button-hover'];
  vuetify.theme.themes.light['primary-button-font-color'] = theme['primary-button-font-color'];
  vuetify.theme.themes.light.primary = theme.primary;
  vuetify.theme.themes.light.secondary = theme.secondary;
  vuetify.theme.themes.light.accent = theme.accent;
  vuetify.theme.themes.light.error = theme.error;
  vuetify.theme.themes.light.info = theme.info;
  vuetify.theme.themes.light.success = theme.success;
  vuetify.theme.themes.light.warning = theme.warning;

  vuetify.theme.themes.dark.surface = theme.surface;
  vuetify.theme.themes.dark['surface-border'] = theme['surface-border'];
  vuetify.theme.themes.dark.surface2 = theme.surface2;
  vuetify.theme.themes.dark['surface2-border'] = theme['surface2-border'];
  vuetify.theme.themes.dark['primary-text-color'] = theme['primary-text-color'];
  vuetify.theme.themes.dark['secondary-text-color'] = theme['secondary-text-color'];
  vuetify.theme.themes.dark['side-item-active'] = theme['side-item-active'];
  vuetify.theme.themes.dark['side-item-hover'] = theme['side-item-hover'];
  vuetify.theme.themes.dark['conversation-sent-bubble'] = theme['conversation-sent-bubble'];
  vuetify.theme.themes.dark['conversation-received-bubble'] = theme['conversation-received-bubble'];
  vuetify.theme.themes.dark['conversation-border-bubble'] = theme['conversation-border-bubble'];
  vuetify.theme.themes.dark['input-bg'] = theme['input-bg'];
  vuetify.theme.themes.dark['input-bg2'] = theme['input-bg2'];
  vuetify.theme.themes.dark['input-border'] = theme['input-border'];
  vuetify.theme.themes.dark['primary-button-hover'] = theme['primary-button-hover'];
  vuetify.theme.themes.dark['primary-button-font-color'] = theme['primary-button-font-color'];
  vuetify.theme.themes.dark.primary = theme.primary;
  vuetify.theme.themes.dark.secondary = theme.secondary;
  vuetify.theme.themes.dark.accent = theme.accent;
  vuetify.theme.themes.dark.error = theme.error;
  vuetify.theme.themes.dark.info = theme.info;
  vuetify.theme.themes.dark.success = theme.success;
  vuetify.theme.themes.dark.warning = theme.warning;

  vuetify.theme.dark = theme.mode === 'dark';

  commit('setSelectedTheme', theme.name);
};

export default {
  changeThemeByName,
  changeTheme
};
